<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'EMAIL-TEMPLATES'" [breadcrumb]="''" [count]="count"
    icon="fa-at">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="emailTemplateGridAdvancedSwitch" [storageKey]="'email-templates-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-TYPE' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-TYPE' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid [data]="view.gridData" [loading]="view.loading"
            [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
            [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
            [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced"
            [group]="view.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
            (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-EMAIL-TEMPLATES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="name" [width]="20" title="{{ 'NAME' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="type" [width]="20" title="{{ 'EMAIL-TEMPLATE-TYPE' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="mimeType" [width]="10" title="{{ 'EMAIL-TEMPLATE-MIME-TYPE' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="language" [width]="10" title="{{ 'EMAIL-TEMPLATE-LANGUAGE' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="15" title="{{ 'LAST-MODIFIED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedDate" [width]="15" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}">
            </kendo-grid-column>
            <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])"
                        [ngClass]="{'extra-padding': !isAllowAddUpdate(dataItem)}">
                    </i>
                    &nbsp;
                    <i *ngIf="isAllowAddUpdate(dataItem)" class="fas fa-trash-alt fa-lg"
                        title="{{ 'DELETE' | translate }}" (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button *ngIf="communityEnabled" appPreventClick kendoButton [primary]="false" type="button"
            class="float-right mt-3 mb-3" (click)="addHandler()"> {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-email-template-edit [isNew]="isNew" [model]="editDataItem" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-email-template-edit>

<!--Delete confirmation dialog-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="deleteDialogOpened = false">
    <p>{{'CONFIRM-EMAIL-TEMPLATE-DELETION' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedEmailTemplate.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteDialogOpened = false">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deleteEmailTemplate()">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>